<template>
  <div style="height: 100%">
    <el-header class="outheader">
      <TopHeader :showInspiration="showInspiration"
                 @inspiration="inspiration" />
    </el-header>
    <div style="width:100%; height:60px"></div>
    <div v-if="showInspiration"
         class="inspiration-content-outer">
      <div class="inspiration-content">
        <div class="title">
          <span class="inspText">灵感中心</span>
        </div>
        <div class="sub-title">
          <span v-if="!showMojing">共享产品自定义分析规则~助你极速获取市场洞察和产品创新灵感！</span>
          <span v-else>共享魔镜CMI各产品自定义分析规则~助你极速获取市场洞察和产品创新灵感！</span>
        </div>
        <div class="headSearch">
          <social-form @formChange="paramsChange"></social-form>
        </div>
        <div class="table-area"
             v-if="Object.keys(formParams).length > 0">
          <vueDatable ref="projTable"
                      @TotalChanged="handleTotalChange"
                      @CurrentChange="handleCurrentChange"
                      @NameClick="NameClick"
                      :options="options_datable_inspiration"
                      :getDataMethod="dataMethod"> </vueDatable>
          <div>
            <el-dialog width="50%"
                       append-to-body
                       :visible.sync="previewDialog">
              <table>
                <thead>
                  <tr>
                    <th style="min-width: 100px; max-width: 150px; text-align: center">名称</th>
                    <th style="min-width: 200px; text-align: center; max-width: 250px">商品标题规则</th>
                    <th v-if="showAttr"
                        style="min-width: 100px; text-align: center; max-width: 150px">属性</th>
                    <th v-if="showAttr"
                        style="min-width: 200px; text-align: center; max-width: 250px">属性规则</th>
                  </tr>
                </thead>
                <tr v-for="item in priviewData"
                    :key="item.rule_group_id">
                  <td style="padding: 10px">
                    <el-input style="width: 180px"
                              size="small"
                              v-model="item.title_name"
                              placeholder=""></el-input>
                  </td>
                  <td style="padding: 10px">
                    <el-input v-model="item.title_rule"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                  <td v-if="showAttr"
                      style="padding: 10px 10px">
                    <el-input v-model="item.attr_name"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                  <td v-if="showAttr"
                      style="padding: 10px 10px">
                    <el-input v-model="item.attr_rule"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                </tr>
              </table>
            </el-dialog>
          </div>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="currentPage"
                           :page-sizes="[10,50,100]"
                           :page-size.sync="currentSize"
                           :pager-count="7"
                           background
                           layout="total ,sizes, ->, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!showInspiration"
         class="content-outer">
      <div class="content">
        <!-- ====== Hero 区：居中标题 + 副标题（保留渐变字体） ====== -->
        <div class="cmi-hero" style="width: 1200px">
          <h1 class="cmi-hero-title">{{$t('inspiration.title')}}</h1>
          <p class="cmi-hero-sub">{{$t('inspiration.subtitle_unified')}}</p>
        </div>
        <!-- ====== 方案D: 流式引导布局 - 统一卡片风格 ====== -->
        <div class="flow-layout"
             v-if="showProductLayout"
             style="width: 1200px">
          <!-- 数据产品卡片行 (5列) -->
          <div class="flow-data-row">
            <!-- 魔镜分析+ -->
            <div class="flow-card flow-card-product" @click="buttonClickHandler('fenxiplus')">
              <div class="flow-card-header">
                <i class="el-icon-data-line"></i>
                <span class="flow-card-title">{{$t('inspiration.analysis')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="flow-card-platforms">
                  <span>{{$t('inspiration.taobao')}}</span>
                  <span>{{$t('inspiration.tmall')}}</span>
                  <span>{{$t('inspiration.jd')}}</span>
                  <span>{{$t('inspiration.douyin')}}</span>
                </div>
                <div class="flow-card-desc">
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.performance_platforms')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.identify_emerging')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.define_custom')}}</p>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button" @click.stop="buttonClickHandler('fenxiplus')">{{$t('inspiration.get_started')}}</el-button>
              </div>
            </div>
            <!-- 海外电商 -->
            <div class="flow-card flow-card-product" @click="buttonClickHandler('oversea')">
              <div class="flow-card-header">
                <i class="el-icon-ship"></i>
                <span class="flow-card-title">{{$t('inspiration.oversea')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="flow-card-platforms">
                  <span>Amazon</span>
                  <span>Shopee</span>
                  <span>Lazada</span>
                  <span>TikTok</span>
                </div>
                <div class="flow-card-desc">
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.access_comprehensive')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.validate_international')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.leverage_analytics')}}</p>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button" @click.stop="buttonClickHandler('oversea')">{{$t('inspiration.get_started')}}</el-button>
              </div>
            </div>
            <!-- 电商聆听 -->
            <div class="flow-card flow-card-product" @click="buttonClickHandler('comment')">
              <div class="flow-card-header">
                <i class="el-icon-edit-outline"></i>
                <span class="flow-card-title">{{$t('inspiration.comment')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="flow-card-platforms">
                  <span>{{$t('inspiration.tmall')}}</span>
                  <span>{{$t('inspiration.jd')}}</span>
                  <span>{{$t('inspiration.douyin')}}</span>
                </div>
                <div class="flow-card-desc">
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.analyze_brand')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.benchmark_product')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.discover_innovation')}}</p>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button" @click.stop="buttonClickHandler('comment')">{{$t('inspiration.get_started')}}</el-button>
              </div>
            </div>
            <!-- 社交聆听 -->
            <div class="flow-card flow-card-product" @click="buttonClickHandler('sociales')">
              <div class="flow-card-header">
                <i class="el-icon-chat-dot-round"></i>
                <span class="flow-card-title">{{$t('inspiration.brand_listen')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="flow-card-platforms">
                  <span>{{$t('inspiration.social_platforms')}}</span>
                </div>
                <div class="flow-card-desc">
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.analyze_product')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.understand_consumer')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.optimize_marketing')}}</p>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button" @click.stop="buttonClickHandler('sociales')">{{$t('inspiration.get_started')}}</el-button>
              </div>
            </div>
            <!-- 增长雷达 -->
            <div class="flow-card flow-card-product" @click="buttonClickHandler('chance')">
              <div class="flow-card-header">
                <i class="el-icon-aim"></i>
                <span class="flow-card-title">{{$t('inspiration.chance')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="flow-card-platforms">
                  <span v-if="language == 'zh'">国内电商</span>
                  <span v-if="language == 'zh'">国内社媒</span>
                  <span>{{$t('inspiration.global_E_commerce')}}</span>
                </div>
                <div class="flow-card-desc">
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.discover_high_growth')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.find_blue_ocean')}}</p>
                  <p><i class="el-icon-circle-check"></i>{{$t('inspiration.instantly_spot')}}</p>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button" @click.stop="buttonClickHandler('chance')">{{$t('inspiration.get_started')}}</el-button>
              </div>
            </div>
          </div>
          <!-- 连接线汇聚区 - 数据流向 AI -->
          <div class="flow-connectors">
            <svg width="100%" height="44" viewBox="0 0 1200 44" preserveAspectRatio="none">
              <defs>
                <linearGradient id="flowGradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="42">
                  <stop offset="0%" stop-color="#5B7CFF" stop-opacity="0.2"/>
                  <stop offset="40%" stop-color="#5B7CFF" stop-opacity="0.5"/>
                  <stop offset="100%" stop-color="#8B6FFF" stop-opacity="0.75"/>
                </linearGradient>
                <radialGradient id="flowDot" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stop-color="#5B7CFF" stop-opacity="0.9"/>
                  <stop offset="100%" stop-color="#5B7CFF" stop-opacity="0"/>
                </radialGradient>
              </defs>
              <path d="M 120 0 C 120 26, 600 26, 600 42" stroke="url(#flowGradient)" fill="none" stroke-width="1.4"/>
              <path d="M 360 0 C 360 26, 600 26, 600 42" stroke="url(#flowGradient)" fill="none" stroke-width="1.4"/>
              <path d="M 600 0 L 600 42" stroke="url(#flowGradient)" fill="none" stroke-width="1.4"/>
              <path d="M 840 0 C 840 26, 600 26, 600 42" stroke="url(#flowGradient)" fill="none" stroke-width="1.4"/>
              <path d="M 1080 0 C 1080 26, 600 26, 600 42" stroke="url(#flowGradient)" fill="none" stroke-width="1.4"/>
              <circle cx="600" cy="42" r="8" fill="url(#flowDot)"/>
              <circle cx="600" cy="42" r="2.5" fill="#5B7CFF"/>
            </svg>
          </div>
          <!-- 三栏: 传统方式 | 镜界AI | AI方式 -->
          <div class="flow-ai-row">
            <div class="flow-card flow-card-compare flow-card-compare--trad">
              <div class="flow-card-header">
                <i class="el-icon-document"></i>
                <span class="flow-card-title">{{$t('inspiration.compare_traditional')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="compare-item"><i class="el-icon-close"></i>{{$t('inspiration.compare_t1')}}</div>
                <div class="compare-item"><i class="el-icon-close"></i>{{$t('inspiration.compare_t2')}}</div>
                <div class="compare-item"><i class="el-icon-close"></i>{{$t('inspiration.compare_t3')}}</div>
                <div class="compare-item"><i class="el-icon-close"></i>{{$t('inspiration.compare_t4')}}</div>
              </div>
            </div>
            <div class="flow-card flow-card-ai">
              <div class="flow-card-header">
                <div class="ai-badge-group">
                  <span class="ai-badge-text">{{$t('inspiration.insight_AI')}}</span>
                </div>
              </div>
              <div class="flow-card-body">
                <p class="ai-desc">{{$t('inspiration.ai_engine_desc')}}</p>
                <div class="ai-values">
                  <div class="ai-value-item"><i class="el-icon-circle-check"></i>{{$t('inspiration.ai_value1')}}</div>
                  <div class="ai-value-item"><i class="el-icon-circle-check"></i>{{$t('inspiration.ai_value2')}}</div>
                  <div class="ai-value-item"><i class="el-icon-circle-check"></i>{{$t('inspiration.ai_value3')}}</div>
                </div>
              </div>
              <div class="flow-card-footer">
                <el-button type="primary" size="small" class="flow-card-button flow-card-button--ai" @click="buttonClickHandler('aipro')">{{$t('inspiration.ai_get_started')}}</el-button>
              </div>
            </div>
            <div class="flow-card flow-card-compare flow-card-compare--ai">
              <div class="flow-card-header">
                <i class="el-icon-success"></i>
                <span class="flow-card-title">{{$t('inspiration.compare_ai')}}</span>
              </div>
              <div class="flow-card-body">
                <div class="compare-item"><i class="el-icon-check"></i>{{$t('inspiration.compare_a1')}}</div>
                <div class="compare-item"><i class="el-icon-check"></i>{{$t('inspiration.compare_a2')}}</div>
                <div class="compare-item"><i class="el-icon-check"></i>{{$t('inspiration.compare_a3')}}</div>
                <div class="compare-item"><i class="el-icon-check"></i>{{$t('inspiration.compare_a4')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-dialog width="30%"
                     append-to-body
                     :visible.sync="showDialog">
            <span style="color:black;">
              {{$t('inspiration.try_free')}}
              <i style="color:crimson; font-size: 30px; font-style: normal;">3</i>
              {{$t('inspiration.start_now')}}
            </span>
            <span slot="footer"
                  class="dialog-footer">
              <el-button type="primary"
                         @click="buttonClick('privilege')">{{$t('inspiration.yes')}}</el-button>
              <el-button @click="showDialog = false">{{$t('inspiration.no')}}</el-button>
            </span>
          </el-dialog>
        </div>
        <div>
          <el-dialog width="30%"
                     append-to-body
                     :visible.sync="showDialog2">
            <span style="color:black;">
              {{$t('inspiration.trial_expire')}}
            </span>
            <span slot="footer"
                  class="dialog-footer">
              <el-button type="primary"
                         @click="showDialog2 = false">{{$t('inspiration.yes')}}</el-button>
              <el-button @click="showDialog2 = false">{{$t('inspiration.no')}}</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <el-footer style="padding: 0;">
      <Footer :showMojing="showMojing" />
    </el-footer>
  </div>
</template>

<script>
import { getUserInfo, getPrivilege, createPrivilege } from '@/api/user'
import TopHeader from '@/components/topHeader.vue'
import Footer from '@/components/footer.vue'
import { getCustomList } from '@/api/inspiration'
import { VueDatatable as vueDatable } from 'common'
import tdComputePlats from '@/components/InspirationTd/tdComputePlats.vue'
import tdTimeSubstring from '@/components/InspirationTd/tdTimeSubstring.vue'
import tdPreviewCustom from '@/components/InspirationTd/tdPreviewCustom.vue'
import SocialForm from '@/components/SocialForm.vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Cookies from 'js-cookie'
export default {
  components: {
    TopHeader,
    Footer,
    vueDatable,
    SocialForm,
  },
  data() {
    return {
      login_url:
        'https://mjlogin.mktindex.com/please_login?service=' +
        window.location.origin +
        '/login&redirect_url=' +
        encodeURIComponent(window.location.href),
      logout_url:
        '/mj_logout?redirect_url=' + encodeURIComponent(window.location.href),
      showDialog: false,
      showDialog2: false,
      btnType: '',
      showInspiration: false,
      total: 0,
      dataMethod: getCustomList,
      currentPage: 1,
      currentSize: 10,
      formParams: {},
      previewDialog: false,
      priviewData: [],
      showAttr: false,
      showMojing: false,
    }
  },
  computed: {
    // 魔镜品牌与产品区分离：OEM 在 mktindex 域名下仍需展示已对接产品
    showProductLayout() {
      return (
        this.showMojing ||
        (this.$store.state.user.loginInfo.is_partner &&
          location.host.includes('mktindex.com'))
      )
    },
    tableParam() {
      return {
        ...this.formParams,
        page: this.currentPage,
        page_size: this.currentSize,
      }
    },
    options_datable_inspiration() {
      return {
        selection: undefined,
        HeaderSettings: false,
        Pagination: false,
        hasPassData: false,
        query: { limit: 10 },
        columns: [
          {
            title: this.$t('inspTh.analyze_name'),
            field: 'analyze_name',
            label: this.$t('inspTh.analyze_name'),
            tdStyle: { minWidth: '200px' },
          },
          {
            title: this.$t('inspTh.product_name'),
            field: 'product_name',
            label: this.$t('inspTh.product_name'),
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.plat'),
            field: 'data',
            label: this.$t('inspTh.plat'),
            tdComp: tdComputePlats,
            tdStyle: { minWidth: '400px' },
          },
          this.$store.state.user.loginInfo.is_partner
            ? {}
            : {
                title: this.$t('inspTh.publish_user'),
                field: 'publish_user',
                label: this.$t('inspTh.publish_user'),
                tdStyle: { minWidth: '100px' },
              },
          {
            title: this.$t('inspTh.publish_time'),
            field: 'publish_time',
            label: this.$t('inspTh.publish_time'),
            sortable: true,
            tdComp: tdTimeSubstring,
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.share_count'),
            field: 'share_count',
            label: this.$t('inspTh.share_count'),
            sortable: true,
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.operation'),
            field: 'analyze_rules',
            label: this.$t('inspTh.operation'),
            tdComp: tdPreviewCustom,
            tdStyle: { minWidth: '100px' },
          },
        ],
        params: this.tableParam,
        _xprops: {},
      }
    },
    language() {
      return localStorage.getItem('language')
    },
  },
  methods: {
    buttonClickHandler(button) {
      this.btnType = button
      let msg = '该功能尚未合作，如有需求请联系项目负责人！'
      getPrivilege({
        product: button,
      })
        .then((res) => {
          if (res.status == 'ok') {
            const pri = res.result.has_pri
            const test = res.result.is_allow_test
            const url = res.result.url
            if (pri == true) {
              // 设置cookie, 跳转cmi各产品时语言一致
              Cookies.set('cmiLanguage', this.language, {
                path: '/',
                expires: 365,
                domain: 'mktindex.com',
              })
              if (location.host == 'cmidev.mktindex.com') {
                // CMI开发环境跳转各产品开发环境
                if (button == 'fenxiplus') {
                  window.open(
                    'https://fenxiplus-mqy-dev.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'oversea') {
                  window.open(
                    'https://oversea-mqy-dev.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'chance') {
                  window.open(
                    'https://chance-cww-dev.mktindex.com/#/concept',
                    '_blank'
                  )
                } else if (button == 'sociales') {
                  window.open(
                    'https://socialwqdev.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'comment') {
                  window.open(
                    'https://commenttest.mktindex.com/dashboard#/',
                    '_blank'
                  )
                } else if (button == 'aipro') {
                  window.open('https://agtest.mktindex.com', '_blank')
                }
              } else if (location.host == 'cmitest.mktindex.com') {
                // CMI测试环境跳转各产品测试环境
                if (button == 'fenxiplus') {
                  window.open(
                    'https://fenxitest.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'oversea') {
                  window.open(
                    'https://overseatest.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'chance') {
                  window.open(
                    'https://chancetest.mktindex.com/#/concept',
                    '_blank'
                  )
                } else if (button == 'sociales') {
                  window.open(
                    'https://socialtest.mktindex.com/#/search',
                    '_blank'
                  )
                } else if (button == 'comment') {
                  window.open(
                    'https://commenttest.mktindex.com/dashboard#/',
                    '_blank'
                  )
                } else if (button == 'aipro') {
                  window.open('https://agtest.mktindex.com', '_blank')
                }
              } else {
                window.open(url, '_blank')
              }
            } else if (test == true) {
              this.showDialog = true
            } else {
              this.showDialog2 = true
            }
          } else {
            this.$message.error(e.error_msg)
          }
        })
        .catch((e) => {
          this.$message.error(msg)
        })
    },

    buttonClick() {
      createPrivilege({
        product: this.btnType,
      }).then((res) => {
        const url = res.result.url
        window.open(url, '_blank')
      })
    },
    inspiration() {
      this.showInspiration = !this.showInspiration
      this.$router.push({
        query: {
          showInspiration: this.showInspiration,
        },
      })
    },
    scrollToProducts() {
      const el = document.querySelector('.flow-data-row')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    handleSizeChange(val) {
      this.currentSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleTotalChange(val) {
      this.total = val
    },
    paramsChange(obj) {
      let { product, plat, cat_name, q, custom_typ } = obj
      this.formParams = { product, plat, cat_name, q, custom_typ }
    },
    NameClick(data) {
      if (data) {
        this.previewDialog = data.previewDialog
        this.priviewData = data.priviewData
        if (this.priviewData[0].attr_title_rel) {
          this.showAttr = true
        } else {
          this.showAttr = false
        }
      }
    },
  },
  async created() {
    const browserFinger = localStorage.getItem('browserFinger')
    if (!browserFinger) {
      const fpPromise = FingerprintJS.load()
      const fp = await fpPromise
      const result = await fp.get()
      localStorage.setItem('browserFinger', result.visitorId)
    }
    const loginInfo = this.$store.state.user.loginInfo
    // TEMP: 禁用登录跳转，方便本地预览布局
    // if (loginInfo.usertype == 'logged_out') {
    //   window.location.href = this.login_url
    // }
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        if (newVal.showInspiration == 'true') {
          this.showInspiration = true
        } else {
          if (this.$store.state.user.loginInfo.is_partner) {
            if (location.host.includes('mktindex.com')) {
              this.showInspiration = false
            } else {
              this.showInspiration = true
            }
          } else {
            this.showInspiration = false
          }
        }
      },
    },
    '$store.state.user.loginInfo.is_partner': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.showMojing = false
        } else {
          this.showMojing = true
        }
      },
    },
  },
}
</script>

<style lang="less">
.msgBtn {
  background-color: #3a63f3 !important;
  border-color: #3a63f3 !important;
}
p {
  font-size: 14px;
}
.outheader {
  position: absolute;
  z-index: 2000;
  width: 100%;
  text-align: right;
  font-size: 12px;
  background-color: #060a32;
  height: 60px !important;
  padding: 0 20px;
  .header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .header-left {
      color: #fff;
      .el-popover {
        position: absolute;
        background: none;
        min-width: 150px;
        border-radius: 4px;
        border: 0px;
        padding: 0px;
        z-index: 2000;
        color: #fff;
        line-height: 1.4;
        text-align: justify;
        font-size: 14px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        word-break: break-all;
        top: 20px;
        left: 200px;
      }
    }
    .header-right {
      .headText {
        color: #ffffff;
      }
      .head-text {
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
.content-outer {
  position: relative;
  height: calc(100% - 140px);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F7F8FC;
  .content {
    width: 100%;
    min-width: 1200px;
    flex-shrink: 0;
    .title {
      width: 1200px;
      font-weight: 400;
      margin: 0 auto 0px auto;
      .title-text {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        line-height: 38px;
        letter-spacing: 0.5px;
        background: linear-gradient(90deg, #1F2A44 0%, #5B7CFF 60%, #8B6FFF 100%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    .subtitle {
      width: 1200px;
      margin: 8px auto 22px auto;
      .subtext {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #6B7488;
        letter-spacing: 0.3px;
      }
    }
    // ====== Hero 区：居中标题 + 副标题（紧凑一屏） ======
    .cmi-hero {
      position: relative;
      margin: 0 auto;
      padding: 2px 0 10px;
      text-align: center;
    }
    .cmi-hero-title {
      margin: 0 0 6px 0;
      font-size: 28px;
      font-weight: 700;
      line-height: 1.2;
      letter-spacing: 0.2px;
      background: linear-gradient(90deg, #1F2A44 0%, #5B7CFF 55%, #8B6FFF 100%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .cmi-hero-sub {
      margin: 0 auto;
      font-size: 13px;
      line-height: 1.5;
      color: #6B7488;
      font-weight: 400;
      letter-spacing: 0.3px;
    }
    // ====== 方案D: 流式引导布局 - AI SaaS 玻璃科技风 ======
    .flow-layout {
      margin: 0 auto;
      position: relative;
      padding: 4px 0 12px;
      // 中央蓝紫辉光 - 数据流向 AI 的视觉光晕
      &::before {
        content: '';
        position: absolute;
        top: 38%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 720px;
        height: 360px;
        background:
          radial-gradient(ellipse at center, rgba(91, 124, 255, 0.10) 0%, rgba(139, 111, 255, 0.06) 35%, transparent 70%);
        pointer-events: none;
        z-index: 0;
        filter: blur(2px);
      }
      > * {
        position: relative;
        z-index: 1;
      }
    }
    // === 统一卡片基类 - 玻璃质感 ===
    .flow-card {
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.78);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      border: 1px solid rgba(91, 124, 255, 0.08);
      border-radius: 16px;
      box-shadow:
        0 1px 2px rgba(91, 124, 255, 0.03),
        0 6px 20px rgba(91, 124, 255, 0.04);
      transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
      padding: 14px 16px 12px;
      &-header {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 9px;
        margin-bottom: 8px;
        i {
          width: 26px;
          height: 26px;
          font-size: 14px;
          color: #5B7CFF;
          background: linear-gradient(135deg, #EEF3FF 0%, #F4EEFF 100%);
          border-radius: 7px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
      }
      &-title {
        font-size: 13px;
        font-weight: 600;
        color: #1F2A44;
        letter-spacing: 0.2px;
      }
      &-body {
        flex: 1;
      }
      &-footer {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        margin-top: 10px;
      }
      &-button {
        background-color: rgba(91, 124, 255, 0.08);
        border-color: rgba(91, 124, 255, 0.18);
        color: #5B7CFF;
        min-width: 96px;
        padding: 6px 20px;
        font-size: 12px;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.25s ease;
        &:hover {
          background-color: #5B7CFF;
          border-color: #5B7CFF;
          color: #ffffff;
          box-shadow: 0 6px 16px rgba(91, 124, 255, 0.28);
        }
        &:focus {
          background-color: rgba(91, 124, 255, 0.08);
          border-color: rgba(91, 124, 255, 0.18);
          color: #5B7CFF;
        }
      }
    }
    // === 数据能力层：5 个产品卡 ===
    .flow-data-row {
      display: flex;
      justify-content: space-between;
      gap: 14px;
    }
    .flow-card-product {
      flex: 1;
      cursor: pointer;
      &:hover {
        border-color: rgba(91, 124, 255, 0.25);
        box-shadow:
          0 2px 4px rgba(91, 124, 255, 0.05),
          0 12px 32px rgba(91, 124, 255, 0.10);
        transform: translateY(-3px);
      }
      .flow-card-platforms {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        margin-bottom: 8px;
        span {
          font-size: 11px;
          background-color: #F4F5F9;
          color: #6B7488;
          font-weight: 400;
          padding: 1px 7px;
          border-radius: 4px;
          white-space: nowrap;
          line-height: 17px;
        }
      }
      .flow-card-desc {
        p {
          font-size: 12px;
          color: #5C6478;
          line-height: 19px;
          margin: 0 0 4px 0;
          display: flex;
          align-items: flex-start;
          // 隐藏原 check 字体图标，改为左侧科技小圆点
          i {
            width: 5px;
            height: 5px;
            min-width: 5px;
            background: #5B7CFF;
            border-radius: 50%;
            margin-right: 8px;
            margin-top: 7px;
            font-size: 0;
            flex-shrink: 0;
            box-shadow: 0 0 6px rgba(91, 124, 255, 0.4);
            &::before {
              display: none;
            }
          }
        }
      }
    }
    // === 数据流向 AI 的连接区 ===
    .flow-connectors {
      height: 44px;
      margin: 2px auto 0;
      svg {
        display: block;
      }
    }
    // === AI 核心 + 对比层 ===
    .flow-ai-row {
      display: flex;
      align-items: stretch;
      justify-content: center;
      gap: 16px;
      margin: 0 auto;
    }
    // --- 传统方式：弱化（灰调降权）---
    .flow-card-compare {
      flex: 0 0 220px;
      padding: 14px 16px 12px;
      .flow-card-header {
        margin-bottom: 10px;
      }
      .compare-item {
        font-size: 12px;
        line-height: 19px;
        margin-bottom: 6px;
        display: flex;
        align-items: flex-start;
        i {
          font-size: 13px;
          margin-right: 7px;
          margin-top: 3px;
          flex-shrink: 0;
        }
      }
    }
    .flow-card-compare--trad {
      background: rgba(250, 251, 253, 0.7);
      border-color: rgba(214, 219, 230, 0.6);
      box-shadow: none;
      .flow-card-header i {
        color: #909399;
        background: #F2F3F7;
      }
      .flow-card-title {
        color: #909399;
        font-weight: 500;
      }
      .compare-item {
        color: #909399;
        i {
          color: #C0C4CC;
        }
      }
    }
    // --- AI 方式：强化（蓝色高亮）---
    .flow-card-compare--ai {
      background: linear-gradient(135deg, rgba(238, 243, 255, 0.55) 0%, rgba(255, 255, 255, 0.85) 100%);
      border-color: rgba(91, 124, 255, 0.18);
      box-shadow:
        0 2px 8px rgba(91, 124, 255, 0.06),
        0 8px 24px rgba(91, 124, 255, 0.05);
      .flow-card-header i {
        color: #5B7CFF;
        background: linear-gradient(135deg, #EEF3FF 0%, #F4EEFF 100%);
      }
      .flow-card-title {
        color: #5B7CFF;
      }
      .compare-item {
        color: #4A5168;
        font-weight: 500;
        i {
          color: #67C23A;
        }
      }
    }
    // --- AI 核心引擎卡（页面视觉中心）---
    .flow-card-ai {
      flex: 0 0 380px;
      position: relative;
      background:
        radial-gradient(ellipse at top, rgba(91, 124, 255, 0.10) 0%, transparent 60%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 255, 0.95) 100%);
      border: 1px solid rgba(91, 124, 255, 0.20);
      box-shadow:
        0 4px 20px rgba(91, 124, 255, 0.10),
        0 16px 48px rgba(91, 124, 255, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
      padding: 14px 18px 14px;
      // 内嵌细描边
      &::after {
        content: '';
        position: absolute;
        inset: 6px;
        border: 1px solid rgba(91, 124, 255, 0.06);
        border-radius: 12px;
        pointer-events: none;
      }
      .flow-card-header {
        justify-content: center;
        margin-top: 0;
        margin-bottom: 6px;
        .ai-badge-group {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .ai-badge-text {
          font-size: 22px;
          font-weight: 700;
          background: linear-gradient(90deg, #5B7CFF 0%, #8B6FFF 50%, #FF9187 100%);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          line-height: 1.2;
          letter-spacing: 0.5px;
        }
      }
      .flow-card-body {
        text-align: center;
        position: relative;
        .ai-desc {
          font-size: 12px;
          color: #6B7488;
          margin: 4px 0 10px 0;
          line-height: 1.45;
        }
        .ai-values {
          text-align: left;
          padding: 10px 14px;
          background: rgba(255, 255, 255, 0.6);
          border: 1px solid rgba(91, 124, 255, 0.10);
          border-radius: 10px;
          .ai-value-item {
            font-size: 12px;
            color: #4A5168;
            line-height: 19px;
            margin-bottom: 4px;
            display: flex;
            align-items: flex-start;
            font-weight: 500;
            &:last-child {
              margin-bottom: 0;
            }
            i {
              color: #5B7CFF;
              font-size: 13px;
              margin-right: 7px;
              margin-top: 3px;
              flex-shrink: 0;
            }
          }
        }
      }
      .flow-card-footer {
        margin-top: 10px;
      }
      .flow-card-button--ai {
        min-width: 130px;
        padding: 8px 24px;
        font-size: 13px;
        font-weight: 500;
        color: #ffffff;
        background: linear-gradient(135deg, #5B7CFF 0%, #8B6FFF 100%);
        border-color: transparent;
        border-radius: 10px;
        box-shadow:
          0 4px 14px rgba(91, 124, 255, 0.30),
          0 8px 24px rgba(139, 111, 255, 0.18);
        &:hover {
          background: linear-gradient(135deg, #6B8AFF 0%, #9B7FFF 100%);
          border-color: transparent;
          color: #ffffff;
          box-shadow:
            0 6px 18px rgba(91, 124, 255, 0.40),
            0 12px 32px rgba(139, 111, 255, 0.25);
          transform: translateY(-1px);
        }
        &:focus {
          color: #ffffff;
          background: linear-gradient(135deg, #5B7CFF 0%, #8B6FFF 100%);
          border-color: transparent;
        }
      }
    }
    .image-box {
      display: flex;
      justify-content: space-evenly;
      width: 1200px;
      margin: 0px auto 24px auto;
      .image-card {
        position: relative;
        width: 370px;
        height: 220px;
        box-shadow: 0px 2px 9px 7px rgba(0, 0, 10, 0.03);
        .text-name {
          position: absolute;
          background: linear-gradient(180deg, #9fdbff 0%, #4c84ff 100%);
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          height: 36px;
          line-height: 36px;
          padding: 0px 12px;
          top: -10px;
          left: 35px;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          .triangle {
            position: absolute;
            width: 0;
            height: 0;
            border: 5px solid;
            border-color: transparent transparent #5084fc #5084fc;
            top: 0px;
            right: -9px;
          }
          .icon {
            font-size: 24px;
            margin-right: 5px;
          }
          .image {
            width: 24px;
            filter: invert(100%);
            margin-right: 5px;
          }
          .plat-title {
            line-height: inherit;
          }
          .plat-title-en {
            font-size: 18px;
            font-weight: normal;
          }
        }
        .deepSeek-card {
          position: absolute;
          background: linear-gradient(
            90deg,
            #f0f3ff 0%,
            #ffffff 50.21%,
            #ecf5ff 100%
          );
          box-shadow: 0px 2px 12px 0px #60636d3d;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          height: 36px;
          line-height: 36px;
          padding: 0px 12px;
          top: -10px;
          left: 35px;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          .deepSeek-title {
            line-height: inherit;
            background: linear-gradient(90deg, #2b6ffe 0%, #ff9187 100%);
            background-clip: text;
            color: transparent;
            font-weight: bold;
          }
          .deepSeek-triangle {
            position: absolute;
            width: 0;
            height: 0;
            border: 5px solid;
            border-color: transparent transparent #dae1fd #dae1fd;
            top: 0px;
            right: -9px;
          }
        }
        .text-explain {
          text-align: left;
          font-size: 13px;
          font-weight: 400;
          color: #616161;
          margin: 10px 0px 10px 35px;
          .paragraph-en {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            margin-bottom: 10px;
          }
          p {
            height: 24px;
            font-size: 13px;
            letter-spacing: 1px;
            margin-bottom: 0;
          }
          .icon {
            vertical-align: -2px;
            color: #6488fa;
            margin-right: 5px;
          }
        }
        .cmi-content {
          width: 100%;
          height: 100%;
          background-color: #ffffff;
          border: 0px #f7f9ff;
          padding: 12px 0px;
          .get-start {
            background-color: #6888ff;
            border-color: #6888ff;
            padding: 6px 10px;
            margin-left: 35px;
          }
          .get-start-en {
            background-color: #6888ff;
            border-color: #6888ff;
            padding: 6px 10px;
            margin-top: 15px;
            margin-left: 20px;
          }
          .linear-text {
            position: absolute;
            background: linear-gradient(90deg, #2b6ffe 0%, #ff9187 100%);
            background-clip: text;
            color: transparent;
            font-weight: bold;
            top: 10px;
            right: 15px;
            .deepSeek-text {
              vertical-align: middle;
              margin-right: 6px;
            }
            .icon-xStar {
              height: 15px;
            }
          }
          .label-box {
            margin-top: 35px;
            margin-left: 35px;
            .cmi-label {
              height: 20px;
              background-color: #dae1fd;
              border-color: #dae1fd;
              color: #2b6ffe;
              font-weight: 500;
              line-height: 20px;
              padding: 0 10px;
              margin-right: 10px;
            }
            .cmi-label-en {
              height: 20px;
              background-color: #dae1fd;
              border-color: #dae1fd;
              color: #2b6ffe;
              font-weight: 500;
              line-height: unset;
              padding: 0 8px;
              margin-right: 10px;
            }
          }
        }
        .ai-pro {
          background: linear-gradient(180deg, #ffffff 0%, #e8eeff 100%);
          box-shadow: 0px 4px 20px 0px #0000001a;
        }
      }
    }
    .el-dialog {
      .el-dialog__body {
        text-align: center;
        padding: 30px 0px;
      }
      .dialog-footer {
        display: flex;
        justify-content: space-evenly;
        .el-button--primary {
          color: #ffffff;
          background-color: crimson;
          border-color: crimson;
          margin-right: 70px;
        }
        .el-button {
          width: 70px;
          height: 40px;
        }
      }
    }
  }
}
.inspiration-content-outer {
  position: relative;
  width: 100%;
  height: calc(100% - 140px);
  overflow-y: auto;
  .inspiration-content {
    background-color: #ffffff;
    margin: 20px 20px 120px 20px;
    padding: 10px 20px;
    .title {
      display: flex;
      align-items: center;
      .inspText {
        font-size: 18px;
        margin: 10px 0px;
      }
    }
    .sub-title {
      margin-top: 20px;
    }
    .headSearch {
      background: #f3f4f6;
      border-radius: 4px;
      padding: 12px;
      margin-top: 20px;
    }
    .table-area {
      width: 100%;
      max-height: 600px;
      overflow: auto;
      margin-top: 20px;
      .table-bordered {
        border: none;
      }
      thead {
        background: #ffffff;
        th {
          color: #000;
          border: none;
          padding: 8px 2px;
        }
      }
      tbody {
        background: #ffffff;
        td {
          vertical-align: inherit;
          background: #ffffff;
          border: none;
          padding: 0px;
        }
      }
      .pagination {
        position: relative;
        width: 100%;
      }
    }
    .el-button {
      color: #3a63f3;
    }
  }
}
</style>
